module.exports = __webpack_public_path__ + "static/media/icon-experts-full@2x.1fd8810d.png";